import styles from "./page.module.css";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { FaArrowAltCircleRight } from "react-icons/fa";

export default function NotFoundPage() {
  return (
    <div className={styles.page}>
      <Header>
        <></>
      </Header>
      <main className={styles.main}>
        <p className={styles.errorText}>Uups, leider ist etwas schiefgelaufen</p>
        <p className={styles.normalText}>Die gewünschte Seite existiert nicht mehr.</p>

        <div className={styles.startseite}>
         <a href="/"> <p>Startseite</p></a>
          <FaArrowAltCircleRight className={commonStyles.commonButtonIcon} />
        </div>
      </main>
      <Footer />
    </div>
  );
}
